
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/privacy-notice",
      function () {
        return require("private-next-pages/qmee/privacy-notice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/privacy-notice"])
      });
    }
  